import React from 'react';

export const LinkIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3547_189)">
      <path
        d="M9.55469 5.57867L11.1016 4.03179C11.7565 3.43486 12.6162 3.11323 13.5022 3.13374C14.3881 3.15425 15.232 3.51532 15.8586 4.14192C16.4852 4.76853 16.8463 5.61247 16.8668 6.49838C16.8873 7.3843 16.5657 8.24405 15.9687 8.89898L13.7578 11.1021C13.4392 11.4219 13.0605 11.6757 12.6436 11.8489C12.2266 12.022 11.7796 12.1112 11.3281 12.1112C10.8767 12.1112 10.4296 12.022 10.0127 11.8489C9.59573 11.6757 9.21708 11.4219 8.89844 11.1021"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4454 14.4212L8.89849 15.9681C8.24356 16.565 7.38381 16.8866 6.4979 16.8661C5.61198 16.8456 4.76804 16.4845 4.14143 15.8579C3.51483 15.2313 3.15376 14.3874 3.13325 13.5015C3.11274 12.6156 3.43437 11.7558 4.0313 11.1009L6.24224 8.89775C6.56088 8.57791 6.93954 8.32413 7.35648 8.15097C7.77343 7.97781 8.22046 7.88867 8.67193 7.88867C9.1234 7.88867 9.57043 7.97781 9.98738 8.15097C10.4043 8.32413 10.783 8.57791 11.1016 8.89775"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3547_189">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
